import invoker from "./invoker.js";
/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */

var toLower =
/*#__PURE__*/
invoker(0, 'toLowerCase');
export default toLower;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/toLower.js
// module id = 1827
// module chunks = 1